import {createAction} from 'typesafe-actions';

export const mapSceneUpdateNotificationMessage = createAction(
    'MAP_SCENE_UPDATE_NOTIFICATION_MESSAGE',
    (action) => (message: string) => action({message}),
);
